import { SVGProps } from 'react'

export const ZipIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 5C3 4.44772 3.44772 4 4 4H8L9 5H16C16.5523 5 17 5.44772 17 6V14C17 14.5523 16.5523 15 16 15H4C3.44772 15 3 14.5523 3 14V5Z"
      stroke="#333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <path
      d="M10 8V12M10 12L8 10M10 12L12 10"
      stroke="#333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
